<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <div>
              <CRow>
                <CCol sm="6">
                  <form class="ml-3 mr-3">
                    <span class="title-form">First Name</span>
                    <input
                      type="text"
                      class="custom-input-user"
                      placeholder="eg. Nazhan"
                    />
                  </form>
                </CCol>
                <CCol sm="6">
                  <form class="ml-3 mr-3">
                    <span class="title-form">Last Name</span>
                    <input
                      type="text"
                      class="custom-input-user"
                      placeholder="eg. Nazhan"
                    />
                  </form>
                </CCol>
              </CRow>
            </div>
            <div style="clear: both"></div>
            <br />
            <div>
              <CRow>
                <CCol sm="12">
                  <form class="ml-3 mr-3">
                    <span class="title-form">Debit/Credit Card Number</span>
                    <input
                      type="text"
                      class="custom-input-user"
                      placeholder="eg. Nazhan"
                    />
                  </form>
                </CCol>
              </CRow>
            </div>
            <div style="clear: both"></div>
            <br />
            <div>
              <CRow>
                <CCol sm="6">
                  <form class="ml-3 mr-3">
                    <span class="title-form">Expiry Date</span>
                    <input
                      type="text"
                      class="custom-input-user"
                      placeholder="eg. Nazhan"
                    />
                  </form>
                </CCol>
                <CCol sm="6">
                  <form class="ml-3 mr-3">
                    <span class="title-form">CVC Number</span>
                    <input
                      type="text"
                      class="custom-input-user"
                      placeholder="eg. Nazhan"
                    />
                  </form>
                </CCol>
              </CRow>
            </div>
          </div>

          <CModal style="position: relative;
              width: 375px;
              height: 454px;
              border-radius: 32px;" size="md" :show.sync="DetailClass">
              <div>
                <h6 class="text-center">
                  <strong>Confirm Payment</strong>
                </h6>
                <br />
                <CCard class="p-3">
                  <label></label>
                  
                  <br />
                  <CRow>
                    <CButton class="btn-select-blue mt-5" @click="GoToPaymentSuccess()">Save and Make Payment</CButton>
                    <CButton class="btn-select-blue mt-5" style="background: #FFFFFF; color: #007CEF;" @click="GoToPaymentSuccess()">No Thanks, I'll Do It Later</CButton>
                    

                    
                  </CRow>
                </CCard>

                
              </div>
            </CModal>

        </div>
      </div>
    </CContainer>
    <div class="bottom-center">
      <CButton class="btn-select-blue mt-5" @click="OpenDetail()">Pay Now</CButton>
    </div>
    <div class="header-top">Debit/Credit Card Payment</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DeleteNotification: false,
      DetailClass: false,
    };
  },
  methods: {
    // GoToExam(){
    //   this.$router.push(
    //     "/RegisterStudentExam"
    //   );
    // }
    OpenDelete() {
      this.DeleteNotification = true;
    },

    OpenDetail() {
      this.DetailClass = true;
    },

    GoToPaymentSuccess() {
      this.$router.push("/ParentProfile/PaymentSuccessful");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #ffffff;

  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}
.custom-btn-add {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;

  color: #007cef;
}
.custom-promo-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  align-items: center;

  color: #000a2c;
}
.custom-promo-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 29px;

  color: #000a2c;
}
.custom-label-title {
  width: 303px;
  height: 20px;

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height */

  /* Blue/Primary */

  color: #007cef;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.title-form {
  width: 158px;
height: 24px;

/* Body/1/Medium */

font-family: 'Montserrat';
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 150%;
/* identical to box height, or 24px */

display: flex;
align-items: center;

/* Black/Dark-001 */

color: #000A2C;


/* Inside auto layout */

flex: none;
order: 0;
align-self: stretch;
flex-grow: 0;
}
</style>